module.exports = __webpack_public_path__ + "img/whats-new-10_cn.4cd26df.jpg";